// Copyright (c) 2017 Comsearch, Inc., All rights reserved

// d is the data object which was selected.
// n is the [name] of the input field so redux-form can target it
// c is the onChange handler that will trigger redux form to update the input.
// this method is used for all 3 auto-suggest fields in Antenna DB SearchAndSelect.
// NOTE: since modelNumber is an array of strings instead of objects,
// we match against d itself and not d[n]
export const assignSuggestValue = (d, n, c) => {
  c(n, n === 'modelNumber' ? d : d[n])
}

export const assignRadioFamily = (d, n, c) => {
  c(`${n}Name`, d[n])
}
